import { ThreeDBarConfig } from './threeDBarTypes';

export const DEFAULT_3D_BAR_CONFIG: ThreeDBarConfig = {
    mode: 'grouped',
    groupGap: 0.2,
    barGap: 0.1,
    yScaleType: 'linear',

    colorMode: 'series',
    paletteId: 'vibrant',
    singleColor: '#4f46e5',
    barOpacity: 0.9,
    barRoundness: false,
    showGrid: true,
    gridIntensity: 0.2,

    showXAxis: true,
    showYAxis: true,
    showZAxis: true,
    showXLabels: true,
    showZLabels: true,
    showValueLabels: false,
    xLabelFontSize: 10,
    zLabelFontSize: 10,
    xLabelAngle: 0,
    yTicks: 5,
    yTickFormat: 'standard',

    enableHover: true,
    enableSelection: true,
    enableZoom: true,
    enablePan: true,
    constrainRotation: true,
    cameraPreset: 'isometric',

    legendType: 'series',
    legendPosition: 'tr',
};
